import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { getBanksAvailable } from '../../../../hooks/api/instapago';
import './instapagostStyle.css';

function ValidateMobilePayment({amount, setPaymentDataPay, setBankValue, payType, setDocType, docType, initialFormData, setInitialFormData}) {
    const [banksAvailables, setBanksAvailables] = useState(null);
    
    // Usar datos iniciales si existen, sino usar estado vacío
    const [formData, setFormData] = useState(initialFormData || {
        reference: "",
        phonenumberclient: "",
        clientId: "",
        bank: "",
        date: "",
        amount: "0.00",
    });
      
    const docTypes = [
        { value: "V", label: "V" },
        { value: "E", label: "E" },
        { value: "J", label: "J" },
        { value: "G", label: "G" }
    ];

    const phoneCodes = [
        { value: "0414", label: "0414" },
        { value: "0424", label: "0424" },
        { value: "0416", label: "0416" },
        { value: "0426", label: "0426" },
        { value: "0412", label: "0412" },
        { value: "0422", label: "0422" }
    ];

    // Inicializar phoneCode basado en los datos existentes
    const getInitialPhoneCode = () => {
        if (initialFormData && initialFormData.phonenumberclient) {
            const code = phoneCodes.find(code => initialFormData.phonenumberclient.startsWith(code.value));
            return code || null;
        }
        return null;
    };

    const [phoneCode, setPhoneCode] = useState(getInitialPhoneCode());
      
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        // Validaciones específicas por campo
        if (name === 'clientId') {
            // Solo permitir números para documento de identidad
            const numericValue = value.replace(/[^0-9]/g, '');
            const newFormData = { ...formData, [name]: numericValue };
            setFormData(newFormData);
            // Actualizar datos iniciales para persistencia
            if (setInitialFormData) {
                setInitialFormData(newFormData);
            }
        } else if (name === 'reference') {
            // Solo permitir números para referencia de pago
            const numericValue = value.replace(/[^0-9]/g, '');
            const newFormData = { ...formData, [name]: numericValue };
            setFormData(newFormData);
            if (setInitialFormData) {
                setInitialFormData(newFormData);
            }
        } else if (name === 'amount') {
            // Manejo especial para el campo de monto con formato 0.00
            const numericValue = value.replace(/[^0-9]/g, ''); // Solo números
            
            let formattedAmount = "0.00";
            
            if (numericValue.length > 0) {
                // Si solo hay 1 dígito, es decimal
                if (numericValue.length === 1) {
                    formattedAmount = `0.0${numericValue}`;
                }
                // Si hay 2 dígitos, son decimales
                else if (numericValue.length === 2) {
                    formattedAmount = `0.${numericValue}`;
                }
                // Si hay más de 2 dígitos, separar parte entera y decimal
                else {
                    const integerPart = numericValue.slice(0, -2);
                    const decimalPart = numericValue.slice(-2);
                    
                    // Limpiar ceros del inicio de la parte entera
                    const cleanIntegerPart = integerPart.replace(/^0+/, '') || '0';
                    
                    formattedAmount = `${cleanIntegerPart}.${decimalPart}`;
                }
            }
            
            const newFormData = { ...formData, [name]: formattedAmount };
            setFormData(newFormData);
            if (setInitialFormData) {
                setInitialFormData(newFormData);
            }
            
            // Posicionar cursor al final después de la actualización
            setTimeout(() => {
                const input = e.target;
                if (input && input.setSelectionRange) {
                    input.setSelectionRange(input.value.length, input.value.length);
                }
            }, 0);
        } else {
            // Para otros campos, permitir cualquier valor
            const newFormData = { ...formData, [name]: value };
            setFormData(newFormData);
            if (setInitialFormData) {
                setInitialFormData(newFormData);
            }
        }
    };
    
    const handleSelectChange = (selectedOption) => {
        const newFormData = { ...formData, bank: selectedOption };
        setFormData(newFormData);
        setBankValue(`0${selectedOption.value}`);
        if (setInitialFormData) {
            setInitialFormData(newFormData);
        }
    };

    const handlePhoneCodeChange = (selectedOption) => {
        setPhoneCode(selectedOption);
        // Actualizar el número de teléfono completo
        const currentPhoneNumber = phoneCode ? formData.phonenumberclient.replace(phoneCode.value, '') : formData.phonenumberclient;
        const fullPhone = selectedOption ? selectedOption.value + currentPhoneNumber : currentPhoneNumber;
        const newFormData = { ...formData, phonenumberclient: fullPhone };
        setFormData(newFormData);
        if (setInitialFormData) {
            setInitialFormData(newFormData);
        }
    };

    const handlePhoneNumberChange = (e) => {
        // Solo permitir números para el teléfono
        const phoneNumber = e.target.value.replace(/[^0-9]/g, '');
        const fullPhone = phoneCode ? phoneCode.value + phoneNumber : phoneNumber;
        const newFormData = { ...formData, phonenumberclient: fullPhone };
        setFormData(newFormData);
        if (setInitialFormData) {
            setInitialFormData(newFormData);
        }
    };

    const getBanksAvailableFn = async ()=>{
        const banks = (await getBanksAvailable())?.bcvBankInfos;
        if(!banks) return;
        
        const options = banks.map(rt => ({
            value: rt.serialNumber,
            label: rt.name,
        }));
        setBanksAvailables(options)
    }      

    useEffect(()=>{
        setPaymentDataPay(formData)
    }, [formData])

    useEffect(()=>{
        getBanksAvailableFn()
    }, [])

    // Función para manejar el foco en el campo de monto
    const handleAmountFocus = (e) => {
        // Posicionar cursor al final cuando se enfoca el campo
        setTimeout(() => {
            if (e.target && e.target.setSelectionRange) {
                e.target.setSelectionRange(e.target.value.length, e.target.value.length);
            }
        }, 0);
    };

    // Efecto para sincronizar con datos iniciales cuando cambian
    useEffect(() => {
        if (initialFormData && Object.keys(initialFormData).length > 0) {
            setFormData(initialFormData);
            // Actualizar phoneCode si hay datos de teléfono
            if (initialFormData.phonenumberclient) {
                const code = phoneCodes.find(code => initialFormData.phonenumberclient.startsWith(code.value));
                setPhoneCode(code || null);
            }
        }
    }, [initialFormData]);

    // Efecto para posicionar cursor al final del campo de monto cuando se renderiza
    useEffect(() => {
        const amountInput = document.querySelector('input[name="amount"]');
        if (amountInput && amountInput.value) {
            setTimeout(() => {
                amountInput.setSelectionRange(amountInput.value.length, amountInput.value.length);
            }, 0);
        }
    }, [formData.amount]);
  
  return (
    <div>
        <div className="alert alert-info mb-4" style={{ borderRadius: '8px', fontSize: '0.9rem' }}>
            <i className="fas fa-info-circle me-2"></i>
            <strong>Importante:</strong> Completa todos los campos con la información exacta de tu pago para una verificación exitosa.
        </div>

        <div className="row g-3">
            <div className="col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-id-card me-2"></i>
                        Documento de Identidad
                    </label>
                    <div className="input-group" style={{ border: '1px solid rgb(195 195 195)', borderRadius: '8px' }}>
                        <div style={{ width: '80px' }}>
                            <Select
                                id="docType"
                                value={docType}
                                onChange={(selected) => setDocType(selected)}
                                options={docTypes}
                                placeholder=''
                                isClearable={false}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        border: '1px solid #e9ecef',
                                        borderRadius: '8px 0 0 8px',
                                        height: '40px',
                                        minHeight: '40px',
                                        fontSize: '0.9rem',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            border: '1px solid #e9ecef'
                                        },
                                        '&:focus': {
                                            border: '1px solid #e9ecef',
                                            boxShadow: 'none'
                                        }
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                        fontSize: '0.9rem'
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        fontSize: '0.9rem'
                                    }),
                                    indicatorSeparator: () => ({
                                        display: 'none'
                                    }),
                                    dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: '8px'
                                    })
                                }}
                            />
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            name="clientId"
                            value={formData.clientId}
                            onChange={handleInputChange}
                            placeholder="Número de documento"
                            maxLength="20"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            style={{ 
                                border: '1px solid #e9ecef', 
                                borderRadius: '0 8px 8px 0', 
                                fontSize: '0.9rem',
                                height: '40px',
                                padding: '0.375rem 0.75rem'
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-hashtag me-2"></i>
                        Referencia de Pago
                    </label>
                    <input
                        type="text"
                        className="form-control form-control-lg"
                        name="reference"
                        value={formData.reference}
                        onChange={handleInputChange}
                        placeholder="Número de referencia"
                        maxLength="20"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        style={{ border: '1px solid rgb(195 195 195)', borderRadius: '8px', fontSize: '0.9rem' }}
                    />
                </div>
            </div>

            {payType === 'mobilePayment' && (
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                            <i className="fas fa-phone me-2"></i>
                            Teléfono del Cliente
                        </label>
                        <div className="input-group" style={{ border: '1px solid rgb(195 195 195)', borderRadius: '8px' }}>
                            <div style={{ width: '100px' }}>
                                <Select
                                    id="phoneCode"
                                    value={phoneCode}
                                    onChange={handlePhoneCodeChange}
                                    options={phoneCodes}
                                    placeholder='Código'
                                    isClearable={false}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            border: '1px solid #e9ecef',
                                            borderRadius: '8px 0 0 8px',
                                            height: '40px',
                                            fontSize: '0.9rem'
                                        }),
                                        option: (provided) => ({
                                            ...provided,
                                            fontSize: '0.9rem'
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            fontSize: '0.9rem'
                                        })
                                    }}
                                />
                            </div>
                            <input
                                type="text"
                                className="form-control form-control-lg"
                                name="phonenumberclient"
                                value={phoneCode ? formData.phonenumberclient.replace(phoneCode.value, '') : formData.phonenumberclient}
                                onChange={handlePhoneNumberChange}
                                placeholder="Número de teléfono"
                                maxLength="7"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                style={{ border: '1px solid #e9ecef', borderRadius: '0 8px 8px 0', fontSize: '0.9rem', height: '40px' }}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-university me-2"></i>
                        Banco
                    </label>
                    <Select
                        id="bank"
                        value={banksAvailables?.find(option => option.value === formData.bank?.value) || null}
                        onChange={handleSelectChange}
                        options={banksAvailables}
                        placeholder="Selecciona un banco"
                        isClearable={false}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                border: '1px solid rgb(195 195 195)',
                                borderRadius: '8px',
                                height: '40px',
                                fontSize: '0.9rem'
                            }),
                            option: (provided) => ({
                                ...provided,
                                fontSize: '0.9rem'
                            }),
                            singleValue: (provided) => ({
                                ...provided,
                                fontSize: '0.9rem'
                            })
                        }}
                    />
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-calendar me-2"></i>
                        Fecha de Pago
                    </label>
                    <input
                        type="date"
                        className="form-control form-control-lg"
                        name="date"
                        value={formData.date}
                        onChange={handleInputChange}
                        style={{ border: '1px solid rgb(195 195 195)', borderRadius: '8px', fontSize: '0.9rem' }}
                    />
                </div>
            </div>

            <div className="col-md-6">
                <div className="form-group">
                    <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-dollar-sign me-2"></i>
                        Monto Pagado
                    </label>
                    <input
                        type="text"
                        className="form-control form-control-lg"
                        name="amount"
                        value={formData.amount}
                        onChange={handleInputChange}
                        onFocus={handleAmountFocus}
                        onBlur={(e) => {
                            // Mantener el foco en el campo
                            setTimeout(() => {
                                if (e.target && e.target.focus) {
                                    e.target.focus();
                                }
                            }, 0);
                        }}
                        placeholder="0.00"
                        inputMode="numeric"
                        pattern="[0-9.]*"
                        autoFocus
                        style={{ 
                            border: '1px solid rgb(195 195 195)', 
                            borderRadius: '8px', 
                            fontSize: '0.9rem',
                            textAlign: 'right',
                            fontFamily: 'monospace'
                        }}
                    />
                    <div className="form-text text-muted mt-1" style={{ fontSize: '0.8rem' }}>
                        <i className="fas fa-info-circle me-1"></i>
                        Monto esperado: <strong>{amount}</strong>
                    </div>
                </div>
            </div>
        </div>

        <div className="alert alert-warning mt-4" style={{ borderRadius: '8px', fontSize: '0.9rem' }}>
            <i className="fas fa-exclamation-triangle me-2"></i>
            <strong>Verificación:</strong> Asegúrate de que todos los datos coincidan exactamente con tu comprobante de pago.
        </div>
    </div>
  )
}

export default ValidateMobilePayment